import React, { Component } from 'react';

export default class StatusContainer extends Component {
  render() {
    const v = this.props.option;
    const style = {
        color: v === 'declined' ? "red" : "inherit"
      };
  
    return (
      <span style={style}>
          {v}
      </span>
    );
  }
};



// WEBPACK FOOTER //
// ./src/containers/Quotes/StatusContainer.js